// React Imports
import React, { Component } from 'react';

// i18n
import { Translate, I18n } from 'react-redux-i18n';

// React Spectrum Components
import { Grid, GridRow, GridColumn } from '@react/react-spectrum/Grid';
import HelpIcon from '@react/react-spectrum/Icon/CallCenter';

// Local project components
import LanguageSelector from './LanguageSelector';
import JarvisChat from './JarvisChat';

// Styles
import '../css/Footer.scss';

/**
 * Component for displaying the global footer.
 *
 * This component displays the global footer. It requires the language selector component
 * and the Jarvis chat component, and includes AdChoices integration.
 *
 * @component
 * @example
 *
 * return (
 *   <Footer />
 * )
 */
class Footer extends Component {
  componentDidMount() {
    // Privacy configuration
    window.fedsConfig = window.fedsConfig || {};
    window.fedsConfig.privacy = window.fedsConfig.privacy || {};
    window.fedsConfig.privacy.otDomainId = window.apcConfig.privacy.client;
    window.fedsConfig.privacy.footerLinkSelector = '.cmp-footer .openPrivacyModal';

    // Inject Privacy.js
    const privacyLib = document.createElement('script');
    privacyLib.src = window.apcConfig.privacy.environment;
    document.body.appendChild(privacyLib);
  }

  // Returns the current year for copyright
  year = () => new Date().getFullYear();

  // Returns the localized URL
  getLocalizedLink = (translationPath) => I18n.t(translationPath);

  /* Allows the component to be updated by a child. Used for when the language
   * changes and we need to re-render the localized links.
   */
  forceUpdateHandler = () => this.forceUpdate();

  render() {
    return (
      <div className="cmp-footer">
        <Grid variant="fixed" className="footer-grid">
          <GridRow className="footer-row">
            <GridColumn size={[12, 3]}>
              <LanguageSelector updateParent={this.forceUpdateHandler} />
            </GridColumn>
            <GridColumn size={[12, 6]}>
              <ul data-testid="copy-rights" className="footer">
                <li>
                  Copyright &copy;
                  {' '}
                  {this.year()}
                  {' '}
                  Adobe. All Rights Reserved.
                </li>
                <li>
                  <a data-testid="privacy-link" href={this.getLocalizedLink('global.footer.privacy_link')}>
                    <Translate value="global.footer.privacy" />
                  </a>
                </li>
                <li>
                  <a data-testid="terms-link" href={this.getLocalizedLink('global.footer.terms_of_use_link')}>
                    <Translate value="global.footer.terms_of_use" />
                  </a>
                </li>
                <li>
                  <a data-testid="coockies-link" href={this.getLocalizedLink('global.footer.cookies_link')}>
                    <Translate value="global.footer.cookies" />
                  </a>
                </li>
                <li>
                  <button data-testid="personalize-btn" type="button" className="openPrivacyModal">Personalize</button>
                </li>
              </ul>
            </GridColumn>
            <GridColumn size={[12, 3]}>
              <a data-testid="helpdesk-link" className="helpdesk" href={this.getLocalizedLink('global.footer.help_link')} target="_blank" rel="noopener noreferrer">
                <HelpIcon />
                <Translate value="global.footer.help" />
              </a>
            </GridColumn>
          </GridRow>
        </Grid>
        <JarvisChat />
      </div>
    );
  }
}

export default Footer;
